var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.noDigits)?_c('span',[_vm._v(_vm._s(_vm._f("numberFormattedShort")(_vm.value)))]):_c('span',[_vm._v(_vm._s(_vm._f("numberFormatted")(_vm.value)))])}
var staticRenderFns = []

export { render, staticRenderFns }